import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../modules';
import { setMenuID } from '../../../modules/tabMenu';
import {
  setImageData,
  setIsOpen,
  tabImageState,
  setIsDetailViewOpen,
  setSelectPhotoData,
  getSearchImageAsyncInImageTab,
  setAddImage,
} from '../../../modules/tabImage';
import Image from '../../../components/search/tabImage';
import { GetSearchImageParamInImageTabType } from '../../../lib/tabImage/type';
import { PostConsumptionBodyType } from '../../../lib/common/type';
import { postConsumptionAsync } from '../../../modules/common';

function ImageContainer() {
  const { searchKeyword } = useSelector(
    (state: RootState) => state.searchKeyword
  );
  const {
    isOpenStatus,
    photosData,
    isDetailViewOpen,
    selectPhotoData,
    imageResult,
    addImageData,
    isLoadingImage,
  } = useSelector((state: RootState) => state.tabImage);
  const dispatch = useDispatch();

  const onSetMenuID = (selectedMenuId: number) => {
    dispatch(setMenuID(selectedMenuId));
  };

  const onSetIsOpen = (isOpenStatus: tabImageState['isOpenStatus']) => {
    dispatch(setIsOpen(isOpenStatus));
  };

  const onSetImageData = (photosData: tabImageState['photosData']) => {
    dispatch(setImageData(photosData));
  };

  const onSetIsDetailViewOpen = (
    isDetailViewOpen: tabImageState['isDetailViewOpen']
  ) => {
    dispatch(setIsDetailViewOpen(isDetailViewOpen));
  };

  const onSetSelectPhotoData = (
    selectPhotoData: tabImageState['selectPhotoData']
  ) => {
    dispatch(setSelectPhotoData(selectPhotoData));
  };

  const onSetAddImage = (addImageData: tabImageState['addImageData']) => {
    dispatch(setAddImage(addImageData));
  };

  const onGetSearchImage = (info: GetSearchImageParamInImageTabType) => {
    dispatch(getSearchImageAsyncInImageTab.request(info));
  };

  const onPostConsumption = (info: PostConsumptionBodyType) => {
    dispatch(postConsumptionAsync.request(info));
  };

  return (
    <Image
      onSetMenuID={onSetMenuID}
      onSetImageData={onSetImageData}
      onSetIsOpen={onSetIsOpen}
      onSetIsDetailViewOpen={onSetIsDetailViewOpen}
      onSetSelectPhotoData={onSetSelectPhotoData}
      onGetSearchImage={onGetSearchImage}
      onSetAddImage={onSetAddImage}
      onPostConsumption={onPostConsumption}
      isOpenStatus={isOpenStatus}
      photosData={photosData}
      isDetailViewOpen={isDetailViewOpen}
      selectPhotoData={selectPhotoData}
      imageResult={imageResult}
      addImageData={addImageData}
      isLoadingImage={isLoadingImage}
    />
  );
}

export default ImageContainer;
